import PropTypes from "prop-types";

import { strCode } from "../../../../../consts";
import { t } from "../../../../../services";

import FlexContainers from "../../../../Containers/FlexContainers";
import SmallButton from "../../../../Buttons/SmallButton";
import { Paragraph2 } from "../../../../Text/Paragraphs";
import Notification from "../../../../Notification/Notification";

import ImportedRecordsTable from "../../ImportedRecordsTable/ImportedRecordsTable";
import { DownloadButtonWrapper, ImportingSummaryWrapper } from "./styled";

const IncorrectRecordsSummary = ({
  incorrectRecords,
  totalLength,
  failedInfo,
  onDownloadCSV,
  ImportedRecordsTableColumns
}) => {
  return (
    <ImportingSummaryWrapper Container={FlexContainers.FlexColumnStart} width={"100%"} gap={24}>
      <Notification
        id="import-error"
        type="error"
        title={t(strCode.FAILED_IMPORT_TITLE)}
        message={t(failedInfo, {
          incorrectRecords: incorrectRecords.length,
          totalLength
        })}
        Component={
          <DownloadButtonWrapper>
            <SmallButton onClick={onDownloadCSV} secondary>
              {t(strCode.DOWNLOAD_CSV_BTN)}
            </SmallButton>
          </DownloadButtonWrapper>
        }
      />

      <Paragraph2>{`${t(strCode.INCORRECT_RECORDS)} (${incorrectRecords.length})`}</Paragraph2>

      <ImportedRecordsTable
        records={incorrectRecords}
        ImportedRecordsTableColumns={ImportedRecordsTableColumns}
      />
    </ImportingSummaryWrapper>
  );
};

IncorrectRecordsSummary.propTypes = {
  incorrectRecords: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number.isRequired,
      correct: PropTypes.bool.isRequired
    }).isRequired
  ),
  totalLength: PropTypes.number.isRequired,
  failedInfo: PropTypes.string.isRequired,
  onDownloadCSV: PropTypes.func.isRequired,
  ImportedRecordsTableColumns: PropTypes.oneOfType([PropTypes.node, PropTypes.object]).isRequired
};

export default IncorrectRecordsSummary;
